import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/core/services/apiservice';
import { ArchivosSubidosInterface, ArchivosSubidosResponseInterface } from 'app/models/archivos-subidos-model';
import { BehaviorSubject } from 'rxjs';


@Injectable({providedIn: 'root'})

export class ArchivosSubidosService {

    archivos: BehaviorSubject<ArchivosSubidosInterface[]> = new BehaviorSubject<ArchivosSubidosInterface[]>([])
    constructor(private api: ApiService, private dialog: MatDialog) { }


    //-----------  Properties -----------//
    get archivos$() {
        return this.archivos.asObservable();
    }

    //-----------------  Methods -----------------//

    getArchivosSubidos( params:{}): Promise<ArchivosSubidosInterface[]> {
        
        return new Promise((resolve, reject) => {
            const url = `/archivos`;
            this.api.GetMethod(url, params, 'Error al obtener los archivos subidos, Intente más tarde')
                .subscribe( (archivos: ArchivosSubidosResponseInterface) => {
                    this.archivos.next(archivos.data);
                    resolve(archivos.data)
                })

        })
    }


    getArchivosByEntity(entidadUuid: string) {
        return this.getArchivosSubidos({entidadUuid})
    }

    actualizarEstadoArchivo(archivo_id: number,  params: any, descripcion?: string) {

        const body = descripcion ? {descripcion} : {}
        const url =`/archivos/${archivo_id}`
        
        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, body, params, 'Ocurrió un error al actualizar la validación del archivo')
                .subscribe(response => {
                    resolve(true)
                })
        })
    }

    eliminarArchivo(idArchivo:number){
        const url = `/archivos/${idArchivo}`;
        return new Promise((resolve, reject)=>{
            this.api.DeleteMethod(url, {}, 'Error al eliminar archivo. Intente más tarde')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })       
    }

    reenviarArchivoAV(body:any){
        const url = `/v-agil/reenviar-documento-oficial`;
        return new Promise((resolve, reject)=>{
            this.api.PostMethod(url, body,{}, 'Error al reenviar archivo. Intente más tarde')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }


    
}